document.addEventListener('DOMContentLoaded', function () {
  var variantOptions = document.querySelectorAll('[data-variant-option]');
  variantOptions.forEach(function(opt) {
    opt.addEventListener('click', function (e) {
      e.preventDefault();
      var group = this.closest('.variant-options');
      if (!group) return;
      group.querySelectorAll('.variant-option').forEach(function(o) { o.classList.remove('is-active'); });
      this.classList.add('is-active');
      var optionName = this.dataset.optionName;
      var optionValue = this.dataset.optionValue;
      var hidden = document.querySelector('input[name="options[' + optionName + ']"]');
      if (hidden) hidden.value = optionValue;
    });
  });
});
